module.exports = __webpack_public_path__ + "media/images/pokerroom/pokerstars/logo-644fe54e55085bd8c2a92add34913990.png";